import React, { useEffect, useState } from 'react'
import { Link, useNavigate } from 'react-router-dom'
import axiosInstance from '../axiosInterceptor'
import { toast } from 'react-toastify'
import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap'
import { ImageLink } from '../constants'

const ProjectCertificate = () => {
    const [loading, setLoading] = useState(false);
    const [contactData, setContactData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [currentPage, setCurrentPage] = useState(
        parseInt(sessionStorage.getItem('currentPage')) || 1
    );
    const [deleteItemId, setDeleteItemId] = useState(null);
    const [modalOpen, setModalOpen] = useState(false);
    const navigator = useNavigate();
    const perPage = 10;

    const fetchData = async (page = 1) => {
        try {
            setLoading(true);
            const response = await axiosInstance.post(
                `project/getAllProjectCertificate`,
                {
                    perPage: perPage,
                    pageNo: page,
                }
            );
            const { data, totalPages } = response.data;
            setContactData(data);
            setTotalPages(totalPages);
            setCurrentPage(page);
            sessionStorage.setItem('currentPage', page);
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        fetchData(currentPage);
    }, [currentPage]);

    const handlePageClick = (page) => {
        if (page >= 1 && page <= totalPages) {
            setCurrentPage(page);
        }
    };

    const handleDelete = async (id) => {
        setDeleteItemId(id);
        setModalOpen(true);
    };

    const confirmDelete = async () => {
        try {
            const response = await axiosInstance.delete(`project/deleteProjectCertificate/${deleteItemId}`);
            if (response.status === 200) {
                toast.success(response.data.message);
                fetchData(currentPage);
            } else {
                toast.error(response.data.message);
            }
        } catch (error) {
            if (error.response) {
                toast.error(error.response.data.message);
            } else {
                toast.error('Something went wrong. Please try again!!');
            }
        } finally {
            setDeleteItemId(null);
            setModalOpen(false);
        }
    };

    const renderPageNumbers = () => {
        const pageNumbers = [];
        const totalPagesToShow = 5;

        let startPage = Math.max(1, currentPage - Math.floor(totalPagesToShow / 2));
        let endPage = Math.min(totalPages, startPage + totalPagesToShow - 1);

        if (endPage - startPage + 1 < totalPagesToShow) {
            startPage = Math.max(1, endPage - totalPagesToShow + 1);
        }

        for (let i = startPage; i <= endPage; i++) {
            pageNumbers.push(
                <li key={i} className={`page-item ${currentPage === i ? 'active' : ''}`}>
                    <button className="page-link" onClick={() => handlePageClick(i)}>
                        {i}
                    </button>
                </li>
            );
        }

        if (startPage > 1) {
            pageNumbers.unshift(
                <li key="left-dots" className="page-item disabled">
                    <span className="page-link">...</span>
                </li>
            );
        }

        if (endPage < totalPages) {
            pageNumbers.push(
                <li key="right-dots" className="page-item disabled">
                    <span className="page-link">...</span>
                </li>
            );
        }

        return pageNumbers;
    };

    if (loading) {
        return <p>Loading.....</p>
    }
    return (
        <>
            <div className="content-wrapper">
                <div className="page-header mt-5">
                    <h3 className="page-title">Project Certificate </h3>
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item">
                                <Link to="/add-project-certificate">
                                    <button type="button" className="btn btn-inverse-info btn-fw"><i className="icon-plus mx-2 mt-2"></i>Add Certificate</button></Link>
                            </li>
                        </ol>
                    </nav>
                </div>
                <div className="row">
                    <div className="col-md-12 grid-margin stretch-card">
                        <div className="card">
                            <div className="card-body">
                                <div className="d-sm-flex align-items-center mb-4">
                                    {/* <h4 className="card-title mb-sm-0">projects Inventory</h4> */}
                                </div>
                                <div className="table-responsive border rounded p-1">
                                    <table className="table text-center">
                                        <thead>
                                            <tr>
                                                <th className="font-weight-bold">Position</th>
                                                <th className="font-weight-bold">Title</th>
                                                <th className="font-weight-bold">Project Name</th>
                                                <th className="font-weight-bold">Image</th>
                                                <th className="font-weight-bold">Certificate</th>
                                                <th className="font-weight-bold">Action</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {contactData.length === 0 ? (
                                                <tr>
                                                    <td colSpan="6" className="text-center">No data found</td>
                                                </tr>
                                            ) : (
                                                contactData.map((item, index) => (
                                                    <tr key={index}>
                                                        <td>{item.position}</td>
                                                        <td>{item.title}</td>
                                                        <td>{item?.projectId?.title}</td>
                                                        <td>
                                                            <img
                                                                className="img-sm rounded-circle"
                                                                src={ImageLink(item.desktopImg)}
                                                                alt="Certificate"
                                                            />
                                                        </td>
                                                        <td>
                                                            <Link to={ImageLink(item?.filePdf)} target="_blank">
                                                                <img src="images/icon/pdf.png" alt="pdf" className="ms-3 me-3" width={60} />
                                                            </Link>
                                                        </td>
                                                        {/* <td>{dateFormat(item.updatedAt)}</td> */}
                                                        <td>
                                                            <div className="template-demo">
                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-primary btn-icon-text"
                                                                    onClick={() => { navigator('/add-project-certificate', { state: item }) }}
                                                                >
                                                                    <i className="icon-pencil btn-icon-append mx-2"></i> Edit
                                                                </button>

                                                                <button
                                                                    type="button"
                                                                    className="btn btn-sm btn-outline-danger btn-icon-text"
                                                                    onClick={() => handleDelete(item._id)}
                                                                >
                                                                    <i className="icon-trash mr-2"></i>Delete
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                ))
                                            )}
                                        </tbody>

                                    </table>
                                </div>
                                <div className="d-flex mt-4 flex-wrap">
                                    <p className="text-muted">
                                        Showing {((currentPage - 1) * perPage) + 1} to {Math.min((currentPage * perPage), contactData.length)} of {totalPages * perPage} entries
                                    </p>
                                    <nav className="ml-auto">
                                        <ul className="pagination separated pagination-info">
                                            <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                                                <button className="page-link" onClick={() => handlePageClick(currentPage - 1)}>
                                                    <i className="icon-arrow-left" />
                                                </button>
                                            </li>
                                            {renderPageNumbers()}
                                            <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                                                <button className="page-link" onClick={() => handlePageClick(currentPage + 1)}>
                                                    <i className="icon-arrow-right" />
                                                </button>
                                            </li>
                                        </ul>
                                    </nav>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <Modal isOpen={modalOpen} toggle={() => setModalOpen(!modalOpen)} >
                <ModalHeader >Confirm Delete
                </ModalHeader>
                <ModalBody>
                    Are you sure you want to delete this project Certificate?
                </ModalBody>
                <ModalFooter>
                    <div className="">
                        <Button
                            type="cancel"
                            className="btn btn-success btn-fw"
                            onClick={() => setModalOpen(!modalOpen)}
                        >
                            No
                        </Button>
                    </div>
                    <div className="">
                        <Button
                            type="button" className="btn btn-danger btn-fw"
                            onClick={confirmDelete}
                        >
                            Yes
                        </Button>
                    </div>
                </ModalFooter>
            </Modal>
        </>
    )
}

export default ProjectCertificate;